import React from "react"

import Index from "../components/pages/workshops.js"

const IndexPage = () => (
  <Index lang="pl" />
)

export default IndexPage